import { render, staticRenderFns } from "./EmailTemplateLinkList.vue?vue&type=template&id=667ad5b9&scoped=true&"
import script from "./EmailTemplateLinkList.vue?vue&type=script&lang=js&"
export * from "./EmailTemplateLinkList.vue?vue&type=script&lang=js&"
import style0 from "./EmailTemplateLinkList.vue?vue&type=style&index=0&id=667ad5b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667ad5b9",
  null
  
)

export default component.exports